import { wrap as withStyle } from 'utils/styles'
import { Header, Paragraph, Button } from 'components/patterns'
import styled from '@emotion/styled'
import Icon from 'components/patterns/Icon'

export default withStyle(
  (props) => `
  `
)

export const StyledHeader = styled(Header)`
  font-size: 18px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.33;
  letter-spacing: normal;
  margin-bottom: 14px;
`

export const TypeNameParagraph = styled(Paragraph)`
  color: rgba(7, 7, 15, 0.7);
  font-family: Arial;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  margin-top: 0;
  margin-bottom: 4px;
`

export const TypeDescriptionParagraph = styled(Paragraph)`
  color: rgba(7, 7, 15, 0.7);
  font-family: Arial;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`

export const StyledParagraphSmall = styled(Paragraph)((props) => {
  const { paragraphColor } = props.theme.color

  return `
    margin-top: 16px;
    margin-bottom: 4px;
    color: ${paragraphColor};
  `
})

export const StyledParagraph = styled(Paragraph)`
  margin-top: 16px;
  margin-bottom: 3px;
`

export const StyledPartDetails = styled.div`
  & svg {
    position: relative !important;
  }
`

export const PanelPartPositioner = styled.div`
  display: inline-block;
  position: relative;
  div {
    position: relative !important;
    margin: 0;

    .border {
      stroke: transparent !important;
    }
  }

  svg:hover {
    cursor: pointer;
  }
`

export const PartIconsWrapper = styled.span`
  position: absolute;
  display: flex;
  width: 100%;
  justify-content: space-between;
  top: 0;
`

export const ReplaceSwitchGraphicsContainer = styled.div`
  vertical-align: top;
  margin-top: 20px;
  margin-left: 15px;
  display: inline-block;
`
export const StyledAlertIcon = styled(Icon)`
  &&& {
    width: 24px;
    margin-right: 0.5rem;
  }
`

export const ErrorIcon = styled(Icon)`
  margin-top: 2px;
  &&& {
    height: 16px;
    width: 18px;
  }
`

export const ErrorLocation = styled.span((props) => {
  const {
    theme: { paragraphErrorColor },
  } = props

  return `color: ${paragraphErrorColor};`
})

export const StyledButton = styled(Button)`
  margin-left: 0px !important;
`

export const StyledLocationContainer = styled.div`
  display: flex;
`

export const InfoIcon = styled(Icon)`
  margin-right: 8px;
  align-self: center;
`

// Replace Switch Selector Styles (PBI 147363)
export const ReplaceSwitchContainer = styled.div`
  margin-top: 8px;
  margin-bottom: 8px;
`

export const ReplaceSwitchLink = styled.a((props) => {
  const {
    theme: { linkColor },
  } = props

  return `
    color: ${linkColor};
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 13px;

    &:hover {
      text-decoration: underline;
      color: ${linkColor};
    }
  `
})

export const ReplaceSwitchDropdown = styled.div`
  margin-top: 8px;
`

// Contextual Help Accordion Styles (PBI 147363)
export const AccordionContainer = styled.div`
  margin-top: 12px;
  width: 100%;
`

export const AccordionHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  user-select: none;
`

export const AccordionHeaderText = styled.span((props) => {
  const { primaryPurple = '#6C18BA' } = props.theme.color || {}

  return `
    font-family: Arial, sans-serif;
    font-size: 12px;
    line-height: 1.33;
    color: ${primaryPurple};
  `
})

// PBI 147363 - Documentation 7: Custom caret SVG component for accordion
export const AccordionCaretSvg = styled.svg`
  transition: transform 0.2s ease;
  transform: ${(props) =>
    props.isExpanded ? 'rotate(180deg)' : 'rotate(0deg)'};
  flex-shrink: 0;
`

// Keep old AccordionCaret for backward compatibility but deprecated
export const AccordionCaret = styled(Icon)`
  transition: transform 0.2s ease;
  transform: ${(props) =>
    props.isExpanded ? 'rotate(180deg)' : 'rotate(0deg)'};

  &&& {
    width: 10px;
    height: 5px;
  }
`

export const AccordionContent = styled.div((props) => {
  const { lightPurple = 'rgba(108, 24, 186, 0.4)' } = props.theme.color || {}

  return `
    display: flex;
    padding: 16px;
    align-items: flex-start;
    gap: 8px;
    align-self: stretch;
    margin-top: 8px;
    border-radius: 8px;
    border: 1px solid ${lightPurple};
    background: #F8F8F9;
  `
})

export const AccordionIconWrapper = styled.div`
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #6c18ba;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const AccordionRefreshIcon = styled(Icon)`
  &&& {
    width: 12px;
    height: 12px;
  }
`

export const AccordionBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1;
`

export const AccordionText = styled.p((props) => {
  const { blackSecondary = 'rgba(7, 7, 15, 0.7)' } = props.theme.color || {}

  return `
    align-self: stretch;
    color: ${blackSecondary};
    font-family: Arial;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
    white-space: pre-line;
    margin: 0;
  `
})

export const AccordionActions = styled.div`
  display: flex;
  justify-content: flex-end;

  button {
    padding-top: 0;
    padding-bottom: 0;
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
`
